import { ArrowLeftRight, Bell, BookOpen, CreditCard, Heart, Home, Package, RotateCcw, Settings, ShoppingCart, Truck } from 'lucide-react';
import type { DashboardNavItem } from './components/DashboardFrame';

export type BuyerSection =
  | 'home'
  | 'library'
  | 'wishlist'
  | 'cart'
  | 'tracking'
  | 'transfers'
  | 'create-content'
  | 'refunds'
  | 'notifications'
  | 'settings';

export const buyerSections: BuyerSection[] = [
  'home',
  'library',
  'wishlist',
  'cart',
  'tracking',
  'transfers',
  'create-content',
  'refunds',
  'notifications',
  'settings',
];

export const buyerNavItemsConfig: Array<Omit<DashboardNavItem, 'label'> & { labelKey?: string; label?: string }> = [
  { id: 'home', labelKey: 'dashboardBuyer.nav.home', to: '/dashboard/home', icon: Home },
  { id: 'library', labelKey: 'dashboardBuyer.nav.library', to: '/dashboard/library', icon: BookOpen },
  { id: 'wishlist', labelKey: 'dashboardBuyer.nav.wishlist', to: '/dashboard/wishlist', icon: Heart },
  { id: 'cart', labelKey: 'dashboardBuyer.nav.cart', to: '/dashboard/cart', icon: ShoppingCart },
  { id: 'tracking', labelKey: 'dashboardBuyer.nav.tracking', to: '/dashboard/tracking', icon: Truck },
  { id: 'transfers', label: 'My Transfers', to: '/dashboard/transfers', icon: ArrowLeftRight },
  { id: 'create-content', label: 'Create Content', to: '/dashboard/create-content', icon: Package },
  { id: 'transactions', label: 'Transactions', to: '/dashboard/transactions', icon: CreditCard },
  { id: 'refunds', labelKey: 'dashboardBuyer.nav.refunds', to: '/dashboard/refunds', icon: RotateCcw },
  { id: 'notifications', labelKey: 'dashboardBuyer.nav.notifications', to: '/dashboard/notifications', icon: Bell },
  { id: 'settings', labelKey: 'dashboardBuyer.nav.settings', to: '/dashboard/settings', icon: Settings },
];
